// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3LsEx","large":"styles_large__1Al0Z"};